import React from 'react';
import { ButtonGroup, Divider, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { I18nLanguage } from '../language.enum';
import { Button } from '../../components/button/button';

export function LanguageSwitcher() {
  const { t: tPrefs, i18n } = useTranslation('prefs');

  const handleChangeLanguage = (language: string): void => {
    i18n
      .changeLanguage(language)
      .then((result) => {
        // Do something with the result
      })
      .catch((error) => {
        // Handle the error here
      });
  };

  return (
    <Grid component="form">
      <Divider />
      <Grid item sx={{ p: 2 }}>
        <Typography variant="h6">i18n testing</Typography>
        <Typography variant="subtitle2">
          Lang: {tPrefs('LANGUAGE_NAME')}
        </Typography>
      </Grid>
      <Grid item sx={{ p: 2 }}>
        <ButtonGroup
          sx={{
            '& .MuiButtonGroup-grouped': {
              minWidth: 90,
            },
          }}
        >
          <Button
            color="secondary"
            size="medium"
            label="AU"
            onClick={() => handleChangeLanguage(I18nLanguage.enAU)}
            variant="contained"
            type="button"
          />
          <Button
            color="secondary"
            label="US"
            size="medium"
            onClick={() => handleChangeLanguage(I18nLanguage.enUS)}
            variant="contained"
            type="button"
          />
        </ButtonGroup>
      </Grid>
      <Grid item sx={{ p: 2 }}>
        <ButtonGroup
          sx={{
            '& .MuiButtonGroup-grouped': {
              minWidth: 90,
            },
          }}
        >
          <Button
            color="secondary"
            label="dev"
            size="medium"
            onClick={() => handleChangeLanguage(I18nLanguage.dev)}
            variant="contained"
            type="button"
          />
          <Button
            color="secondary"
            label="pseudo"
            size="medium"
            onClick={() => handleChangeLanguage(I18nLanguage.pseudo)}
            variant="contained"
            type="button"
          />
        </ButtonGroup>
      </Grid>
    </Grid>
  );
}
